import { createProviderStateHook } from '@dor/utils';

import { TokenPriceProvider, TokenPriceProviderContext } from './provider.tsx';

const useTokenPriceProvider = createProviderStateHook(
  TokenPriceProvider,
  TokenPriceProviderContext
);

const useTokenPrices = () => {
  const { tokenPrices } = useTokenPriceProvider();
  return tokenPrices;
};

export { useTokenPriceProvider, useTokenPrices };
